import * as api from '../api';
import { PURGE } from 'redux-persist';

const GET_FLEETS = 'fleets/GET_FLEETS';
const SELECT_FLEET = 'fleets/SELECT_FLEET';
const GET_VEHICLE_TYPES = 'fleets/GET_VEHICLE_TYPES';
const initialState = {
  fleets: [],
  vehicleTypes: null, // Will store { fleetId: [vehicleTypes] }
  vehicleTypesLoading: false,
  vehicleTypesError: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_FLEETS:
      console.log('[DEBUG] GET_FLEETS reducer - state:', state, 'action.data:', action.data);
      // Keep the selected fleet, if one has been selected; otherwise, default to the first
      const fleetsArray = Array.isArray(state) ? state : state.fleets || [];
      const selectedFleet = fleetsArray.find(({ selected }) => selected === true);
      if (selectedFleet) {
        action.data.forEach((fleet) => (fleet.selected = fleet.id === selectedFleet.id));
      } else {
        action.data.forEach((fleet, index) => (fleet.selected = index === 0));
      }
      // Support both old array format and new object format
      const newState = Array.isArray(state) 
        ? [...action.data]
        : { ...state, fleets: [...action.data] };
      console.log('[DEBUG] GET_FLEETS reducer - new state:', newState);
      return newState;
    case SELECT_FLEET:
      if (Array.isArray(state)) {
        const newState = [...state];
        newState.forEach((fleet) => (fleet.selected = fleet.id === action.data));
        return [...newState];
      } else {
        const newFleets = [...state.fleets];
        newFleets.forEach((fleet) => (fleet.selected = fleet.id === action.data));
        return { ...state, fleets: newFleets };
      }
    case GET_VEHICLE_TYPES:
      return {
        ...state,
        vehicleTypes: {
          ...state.vehicleTypes,
          [action.fleetId]: action.data,
        },
        vehicleTypesLoading: false,
        vehicleTypesError: null,
      };
    case PURGE:
      return initialState;
    default:
      return state;
  }
}

export const getFleets = (jwt) => {
  return (dispatch) => {
    console.log('[DEBUG] getFleets called with token:', jwt ? 'Token present' : 'No token');
    return api.getFleets(jwt)
      .then(({ fleets }) => {
        console.log('[DEBUG] getFleets API response:', fleets);
        dispatch({ type: GET_FLEETS, data: fleets });
        return fleets;
      })
      .catch((error) => {
        console.error('[DEBUG] getFleets API error:', error);
        throw error;
      });
  };
};

export const selectFleet = (fleetId) => {
  return (dispatch) => dispatch({ type: SELECT_FLEET, data: fleetId });
};

/**
 * Load available vehicle types for a fleet
 * Used in CreateReservationDialog to populate vehicle type dropdown
 * @param {string} fleetId - Fleet ID
 * @returns {Promise} - Resolves with vehicle types array
 */
export const getVehicleTypes = (fleetId, startDate = null, endDate = null) => {
  return async (dispatch) => {
    try {
      const data = await api.getAvailableVehicleTypes(fleetId, startDate, endDate);
      dispatch({ type: GET_VEHICLE_TYPES, fleetId, data });
      return data;
    } catch (error) {
      console.error('Error loading vehicle types:', error);
      throw error;
    }
  };
};
